<div class="bmc-working-time-schema-hours">
  <div class="bmc-working-time-schema-hours__table">
    <p class="bmc-working-time-schema-hours__description">{{"WORKING_TIME_SCHEMA.CUSTOM_WORKING_HOURS_DESCRIPTION" | translate}}</p>
    <ng-container *ngIf="!(customWorkingHours$ | async)">
      <!--
      <div *ngIf="!(customWorkingHours$ | async).length">
        <p>{{"WORKING_TIME_SCHEMA.ADDITIONAL_NON_WORKING_DAYS_EMPTY" | translate}}</p>
      </div>
      -->
    </ng-container>
    <table class="bz-table bz-space--stack-xl">
      <thead>
      <tr>
        <th class="bz-table__cell bz-table__cell--sortable" *ngFor="let col of columns">
          <div class="bz-table__col-title" *ngIf="col.visible">
            <span class="bz-space--inline-xs">{{ col.value | translate}}</span>
          </div>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let day of (customWorkingHours$ | async)">
        <td class="bz-table__cell" *ngFor="let col of columns" [ngClass]="{'bz-color-bg--theme-100': ( selectedSchemaRange && (day.fromDate === selectedSchemaRange?.fromDate) && (day.toDate === selectedSchemaRange?.toDate) )}">
          <div *ngIf="col.visible" class="bmc-working-time-schema-hours__table__cell">
            <div class="bz-table__cell-row bz-table__cell-row--center" *ngIf="col.type === 'date' ">
              {{ day[col.key] | date:'MM/dd/yyyy'}}
            </div>
            <div class="bz-table__cell-row bz-table__cell-row--center" *ngIf="col.type === 'number' ">
              {{getDaysBetween(day["fromDate"], day["toDate"])}}
            </div>
            <bzg-button-icon *ngIf="col.type === 'edit' "[icon]="'icon-edit'" class="bz-space--inline-s" (click)="selectSchemaRange(day)"></bzg-button-icon>
            <bzg-button-icon *ngIf="col.type === 'delete' "[icon]="'icon-delete'" class="bz-space--inline-s" (click)="deleteWorkingTimeSchemaRange(day)"></bzg-button-icon>
            <bzg-button-icon *ngIf="col.type === 'detail'" [icon]="'icon-timer'" class="bz-space--inline-s"
                             #timeDetailsTrigger="bzgPopover" [bzgPopover]='timeDetails' [bzgPopoverPosition]="'right'">
              <bzg-popover #timeDetails>
                <time-details [customWorkingHour]="day" (onClose)="timeDetailsTrigger.hide()"></time-details>
              </bzg-popover>
            </bzg-button-icon>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <ng-form #workingHoursForm="ngForm" class="bmc-working-time-schema-hours__config">
    <div class="bmc-working-time-schema-hours__config--scrollable bz-space--stack-m">
      <div class="bz-space--stack-s">
        <label class="bz-form-label">{{'WORKING_TIME_SCHEMA.DATE_TYPE' | translate}}</label>
      </div>
      <bzg-select class="bz-space--stack-m" [placeholder]="'WORKING_TIME_SCHEMA.SELECT_DATE_TYPE' | translate" name="select" [(value)]="currentDateType">
        <bzg-option [value]="'exact'">{{'WORKING_TIME_SCHEMA.EXACT' | translate}}</bzg-option>
        <bzg-option [value]="'range'">{{'WORKING_TIME_SCHEMA.RANGE' | translate}}</bzg-option>
      </bzg-select>
      <bzg-date-picker *ngIf="currentDateType==='exact'" [(ngModel)]="onDate" name="on-date">
        {{'WORKING_TIME_SCHEMA.ON_DATE' | translate}}
      </bzg-date-picker>
      <bzg-date-picker *ngIf="currentDateType==='range'" [(ngModel)]="startDate" [maxDate]="finishDate" name="start-date">
        {{'WORKING_TIME_SCHEMA.START_DATE' | translate}}
      </bzg-date-picker>
      <bzg-date-picker *ngIf="currentDateType==='range'" [(ngModel)]="finishDate" [minDate]="startDate" name="finish-date">
        {{'WORKING_TIME_SCHEMA.FINISH_DATE' | translate}}
      </bzg-date-picker>

      <div class="bmc-working-time-schema-hours__time">
        <div *ngFor="let time of timeList; let i = index">
          <div class="bmc-working-time-schema-hours__time__wrapper">
            <div class="bmc-working-time-schema-hours__time__item bz-space--inset-squish-s">
              <bzg-time-picker [showSeconds]="false" [name]="'fromTime' + i" [(ngModel)]="time.fromTime">
                {{( 'WORKING_TIME_SCHEMA.FROM') | translate}}:
              </bzg-time-picker>
              <bzg-time-picker [showSeconds]="false" [name]="'toTime' + i" [(ngModel)]="time.toTime">
                {{( 'WORKING_TIME_SCHEMA.TO') | translate}}:
              </bzg-time-picker>
            </div>
            <div class="bmc-working-time-schema-hours__time__item__icons">
              <bzg-button-icon *ngIf="timeList.length > 1" (click)="removeTimeItem(i)" class="bmc-container__environment__refresh__icon bz-color-bg--theme-100 bz-border-radius--l bz-space--stack-s" icon="icon-minus"></bzg-button-icon>
              <bzg-button-icon *ngIf="timeList.length < 5" (click)="addTimeItem()" class="bmc-container__environment__refresh__icon bz-color-bg--theme-100 bz-border-radius--l" icon="icon-plus"></bzg-button-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!selectedSchemaRange">
      <bzg-button-secondary *ngIf="currentDateType" [disabled]="isInvalid()" class="bmc-working-time-schema-hours__config__button bz-space--inline-m"
                            [size]="'s'" (click)="onSetCustomWorkingHours()">
        {{'WORKING_TIME_SCHEMA.SET_NEW_WORKING_HOURS' | translate}}
      </bzg-button-secondary>
    </ng-container>
    <div *ngIf="selectedSchemaRange">
        <bzg-button-primary *ngIf="currentDateType" [disabled]="isInvalid()" 
          class="bmc-working-time-schema-days__config__button bz-space--inline-s" [size]="'s'" (click)="modifySchemaRange(selectedSchemaRange)">
          {{'WORKING_TIME_SCHEMA.APPLY_CHANGES' | translate}}
        </bzg-button-primary>
        <bzg-button-secondary *ngIf="currentDateType" [disabled]="isInvalid()" 
          class="bmc-working-time-schema-days__config__button bz-space--inline-s" [size]="'s'" (click)="cancelModify()">
          {{'GLOBAL.CANCEL' | translate}}
        </bzg-button-secondary>
      </div>
  </ng-form>
</div>
